<template>
    <div class="quickpay-overview">
        <QuickpayPaymentHeader
            :companyName="data.corporation.name"
            :amount="data.document.amount_due"
            :currency="data.document.currency"
            :logoUrl="data.corporation.logoUrl"
            :hideAmount="data.document.hide_amount_due"
        />
        <QuickpayDownloadDocument
            :docType="data.document.doctype"
            :docId="data.document.id"
            :corpId="data.document.corpid"
            :pdfUrl="data.document.pdf_link"
            :pdfReady="data.document.pdf_ready"
            :hash="hash"
            :documentNumber="data.document.number"
            :documentStep="data.document.step"
            :expired="data.document.expired"
        />
        <QuickpayDeadlines
            v-if="hasDeadlines"
            :deadlines="data.deadlines"
            :currency="data.document.currency"
        />
    </div>
</template>

<script>
import QuickpayPaymentHeader from 'vcomponents/quickpay/QuickpayPaymentHeader.vue';
import QuickpayDownloadDocument from './QuickpayDownloadDocument.vue';
import QuickpayDeadlines from './QuickpayDeadlines.vue';

export default {
    components: {
        QuickpayPaymentHeader,
        QuickpayDownloadDocument,
        QuickpayDeadlines,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        hash: {
            type: String,
            required: true,
        },
    },
    computed: {
        hasDeadlines() {
            return this.data.deadlines?.length > 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.quickpay-overview {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1023px) {
        gap: var(--spacing-4);
    }
}
</style>
